<app-service-detail #ServiceDetailComponent [context]="context" [location]="'nav.3_roles'">

    <div class="row w-100 m-0 position-relative">
        <div class="col-md-12 px-md-5 ml-auto" style="position: relative;">
            <flow
                [orderedMenuRoles]="orderedMenuRoles"
                [determinantMapById]="determinantMapById"
                [institutions]="institutions"
                [baseUrl]="baseUrl"
                [serviceRegistrations]="serviceRegistrations"
                [selectedRoleId]="selectedRoleId"
                (tutorialOpened)="onTutorialOpened($event)"
                (determinantSelectionChanged)="onDeterminantSelectionChanged($event)"
                (registrationSelectionChanged)="onRegistrationSelectionChanged($event)"></flow>
            <div class="row list-header mb-1">
                <tutorial-layer *ngIf="context['service'].tutorials && context['service'].tutorials.serviceRoles"
                        title="{{ 'Processing roles' | translate }}"
                        [isClosed]="rolesTutorialClosed"
                        [hideTrigger]="true"
                        [editorData]="context['service'].tutorials['serviceRoles']"
                        (saveTutorial)="serviceDetailComponent.updateService()"
                        (closingTutorial)="onTutorialClosed($event)">
                </tutorial-layer>
            <!--
                <div class="col-8">
                    <h1 class="list-header-title bots mb-1">{{'Processing roles' | translate}}</h1>
                </div>
            -->
            </div>
            <ng-content></ng-content>
        </div>
        <!--
        <app-list-grid class="col-md-12 px-md-5 ml-auto padding mb-4"
                   *ngIf="!hideList && (activeMenuRoles && activeMenuRoles.length > 0)"
                   [items]="activeMenuRoles"
                   [determinantMapById]="determinantMapById"
                   [baseUrl]="baseUrl"
                   [orderedMenuRoles]="orderedMenuRoles"
                   [institutions]="institutions"
                   [multipleSelect]="true"
                   [expanded]=true
                   [hasTutorial]=false
                   headingTextSize="SMALL"
                   [context]="context"
                   [isCollapsible]="true"
                   [contextProperty]="'service'"
                   [tutorialProperty]="'serviceRoles'"
                   (saveTutorial)="serviceDetailComponent.updateService()"
                   [rolesFlow]=true
                   [statusIcons]=true
                   [listToggle]=true
                   [selectAll]=true
                   headingText="Active roles available in the service"
                   (updateFunction)="updateRole($event)"
                   (deleteFunction)="deleteRole($event)"
                   (determinantSelectionChanged)="onDeterminantSelectionChanged($event)"
                   (filterBy)="onFillField($event)"
                   createNewText1Part="Select an existing role or click on"
                   createNewText2Part="to create a new role">
                   <button (click)="openNewRoleLayer()"
            class="btn btn-sm btn-primary mr-1">{{'Add' | translate}}</button>
        </app-list-grid>
        -->
        <div class="shadow"></div>
        <app-list-grid class="col-md-12 px-md-5 ml-auto"
                   [items]="menuRoles"
                   [determinantMapById]="determinantMapById"
                   [baseUrl]="baseUrl"
                   [orderedMenuRoles]="orderedMenuRoles"
                   [expanded]=true
                   headingTextSize="SMALL"
                   [rolesFlow]=false
                   [multipleSelect]=true
                   [selectAll]=true
                   [statusIcons]=true
                   [isCollapsible]="true"
                   [listToggle]=true
                   [isCollapsed]="orderedMenuRoles?.length ? true : false"
                   headingText="Other roles available in the service"
                   (updateFunction)="updateRole($event)"
                   (deleteFunction)="deleteRole($event)"
                   (determinantSelectionChanged)="onDeterminantSelectionChanged($event)"
                   (filterBy)="onFillField($event)"
                   createNewText1Part="Select an existing role or click on"
                   createNewText2Part="to create a new role">
            <button (click)="openNewRoleLayer()"
            class="btn btn-sm btn-primary mr-1">{{'Add' | translate}}</button>
        </app-list-grid>
        <app-list-grid class="col-md-12 px-md-5 ml-auto"
                   *ngIf="ghostRoles?.length"
                   [items]="ghostRoles"
                   [determinantMapById]="determinantMapById"
                   [baseUrl]="baseUrl"
                   [orderedMenuRoles]="orderedMenuRoles"
                   [expanded]=true
                   headingTextSize="SMALL"
                   [rolesFlow]=false
                   [multipleSelect]=true
                   [hideSearch]=true
                   [readOnly]=true
                   [selectAll]=true
                   [isCollapsed]=true
                   [statusIcons]=false
                   [isCollapsible]="true"
                   [listToggle]=true
                   headingText="Ghost roles"
                   (deleteFunction)="deleteRole($event)">
        </app-list-grid>
        <app-new-role *ngIf="showRoleAdd"
            [roleName]="roleNameField"
            [showRoleAdd]="showRoleAdd"
            [determinantMapById]="determinantMapById"
            [institutions]="institutions"
            (modalClosedEvent)="closeLayer();"
            (modalAddedEvent)="addedRole();"></app-new-role>
    </div>
    <div class="col-md-12 ml-auto px-md-5" *ngIf="hideList">
        <!--
        <div class="fix-flow-space">
            <flow
                *ngIf="store.state.common.sections.active == false"
                class="row"
                [orderedMenuRoles]="orderedMenuRoles"
                [institutions]="institutions"
                [baseUrl]="baseUrl"
                [determinantMapById]="determinantMapById"
                (determinantSelectionChanged)="onDeterminantSelectionChanged($event)"
                ></flow>
        </div>
        -->
        
    </div>
</app-service-detail>
